module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABRElEQVR4Ae3gAZAkSZIkSRKLqpm7R0REZmZmVlVVVVV3d3d3d/fMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMdHd3d3dXV1VVVVVmZkZGRIS7m5kKz0xmV3d1d3dPz8zMzMxMomwfl7TLvw2y/WBJt/Jvg2y/tqTf5t8G2f4oSV/Dvw2y/VuSXod/G2T7IvAQSbv86yHbBj5H0mfzr4dsG9gFHiJpl38dZNtc8TmSPpt/HWTbXLELvI6kv+ZFh2ybZ7sVeB1Jt/KiQbbNc7oVeB1Jt/IvQ7bN87oVeBtJf80Lh2ybF+xzJH02LxiybV64W4HPAX5a0i7PCdk2L7rfBr4HuBXYBW79R5iiVR72gveFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/layout/pages/home/images/left.png
// module id = /8xh
// module chunks = 6